import { Field, ImageField, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';

export type SearchLocationFilterField = {
  id?: string;
  name?: string;
  fields?: {
    filterLabel?: Field<string>;
    distanceFilterLabel?: Field<string>;
    clearLabel?: Field<string>;
    applyLabel?: Field<string>;
  };
};

export type DistanceOption = {
  id?: string;
  fields?: {
    label?: Field<string>;
    value?: Field<string>;
  };
};

export type CommunityItem = {
  id?: string;
  fields?: {
    label?: Field<string>;
    link?: LinkField;
  };
};

export type SearchLocationFields = {
  desktopImage?: ImageField;
  tabletImage?: ImageField;
  mobileImage?: ImageField;
  badgeText?: RichTextField;
  browseByLabel?: Field<string>;
  searchSitesButtonText?: Field<string>;
  locationIcon?: ImageField;
  supportingSubtitle?: RichTextField;
  primaryHeading?: RichTextField;
  primaryHeadingGradientText?: Field<string>;
  primaryHeadingGradientColor?: Field<string>;
  searchPlaceholderText?: Field<string>;
  useMyLocationText?: Field<string>;
  isValidationRequired?: Field<boolean>;
  validationErrorText?: Field<string>;
  permissionDenied?: Field<string>;
  positionUnavailable?: Field<string>;
  communities?: CommunityItem[];
  clearFilterLabel?: Field<string>;
  filterFields?: SearchLocationFilterField[];
  sitesFoundText?: Field<string>;
  viewSiteLabel?: Field<string>;
  activeStudiesLabel?: Field<string>;
  closestLabel?: Field<string>;
  conditionsLabel?: Field<string>;
  recruitingNowLabel?: Field<string>;
  mapLocationIcon?: ImageField;
  defaultDistance?: DistanceOption[];
  primaryLabelBgColor?: Field<string>;
  secondaryLabelBgColor?: Field<string>;
};

export type LocationSearchCoords = {
  lat: number;
  lng: number;
};

export type SearchLocationHeroProps = ComponentProps & {
  fields?: SearchLocationFields;
  nationwideTotal?: number;
  communities?: string[];
  community?: string | null;
  onCommunitySelect?: (community: string) => void;
  onLocationSearch?: (coords: LocationSearchCoords) => void;
};

export const SEARCH_LOCATION_DATASOURCE_ID = '8BF1D6DB-D1C0-47A5-926D-9A857F1726A0';

export const UNRECOGNIZED_LOCATION_MESSAGE =
  "We couldn't find that location. Please try a different ZIP, city, or state.";
